import React, { useEffect, useState } from 'react'
import Link from 'next/link'
import Image from 'next/image'
import { s3Static } from '../../utils/constants'
import { useRouter } from 'next/router'
import { BlogItem } from './BlogItem'

export const BlogsList = (props) => {
    const router = useRouter()
    const isListAll = props.listAll
    const [ blogs, setBlogs ] = useState(props.blogs)
    const wpPosts = props.wpPosts
    const wpNewPosts = props.wpNewPosts
    const theme = props.theme || "default"
    
    useEffect(()=> {
        let tempBlogs = props.blogs;
        for(let x = 0; x < tempBlogs.length; x++){
            if(tempBlogs[x].url === router.pathname){
                tempBlogs.splice(x, 1)
            }
        }
        if(!isListAll){
            let l = 6
            if(wpNewPosts?.length > 0){
                l = wpNewPosts?.length > 6 ? 0 : 6 - wpNewPosts?.length
            }
            setBlogs(tempBlogs.slice(0,l))
        }
    }, [router.pathname, props.blogs, wpNewPosts, isListAll])

  return (
    <div className={`${theme === "dark" ? "bg-slate-900" : ""}`}>
        {/* Mobile fold budget: this grid was single-column on phones, so each card ran
            full-width with a 4:3 image (~280px) plus an 80px `py-10` button row. Six
            cards cost ~3,500px. Now 2-up on mobile with compact cards. */}
        <div className={`grid grid-cols-2 md:grid-cols-3 max-w-6xl mx-auto gap-x-3 sm:gap-x-5 gap-y-3 py-5`}>
            {wpNewPosts?.length > 0  &&
                <>
                    {[...wpNewPosts].map((post, i) =>                
                        <div className={`p-4 space-y-2 mt-5 shadow rounded-xl ${theme === "dark" ? "border border-gray-700" : "border"}`} key={i}>
                            <BlogItem post={post} theme={theme}></BlogItem>
                        </div>
                    )}
                </>
            }
            {blogs?.length > 0 &&
                <>
                    {[...blogs].map((blog, i) =>                
                        <div className={`p-2.5 md:p-4 space-y-1.5 md:space-y-2 mt-2 md:mt-5 shadow rounded-xl ${theme === "dark" ? "border border-gray-700" : "border"}`} key={i}>
                            <Link href={blog.url} prefetch={false} className='text-orange-600'>
                                <h3 className='md:h-20 font-bold text-center text-sm md:text-base line-clamp-3 md:line-clamp-none'>{blog.title}</h3>
                            </Link>
                            {/* Image is 16:9 on mobile (shorter than 4:3) and only ~50vw wide
                                now that the grid is 2-up, so `sizes` is corrected to match. */}
                            <div className='relative w-full aspect-video md:aspect-4/3 mt-2 md:mt-3 rounded-xl overflow-hidden'>
                                <Image
                                        src={s3Static + blog.image}
                                        fill
                                        style={{objectFit: 'cover'}}
                                        placeholder='blur'
                                        blurDataURL={s3Static + "placeholder.png"}
                                        alt={blog.imageAlt}
                                        sizes="(max-width: 768px) 50vw, 33vw"
                                        priority={i < 3}
                                />          
                            </div>
                            {/* Snippet hidden on mobile - the title is the actual link anchor
                                and the card stays scannable without a 3-line teaser. */}
                            <p className='hidden md:block text-sm text-gray-500 leading-7 overflow-hidden'>
                                {blog.snippet}
                            </p>
                            <div className='pt-2 pb-1 md:py-10 text-center'>
                                <Link href={blog.url} prefetch={false} className='inline-block text-orange-600 text-xs md:text-base px-2.5 py-1.5 md:px-4 md:py-3 border border-amber-600 rounded-xl'>
                                    Continue Reading
                                </Link>
                            </div>
                        </div>
                    )}
                </>
            }
            {(wpPosts?.length > 0 && isListAll ) &&
                <>
                    {[...wpPosts].map((post, i) =>                
                        <div className={`p-4 space-y-2 mt-5 shadow rounded-xl ${theme === "dark" ? "border border-gray-700" : "border"}`} key={i}>
                            <BlogItem post={post} theme={theme}></BlogItem>
                        </div>
                    )}
                </>
            }
        </div>
    </div>
  )
}
